import { render, staticRenderFns } from "./p2.vue?vue&type=template&id=5835823e&scoped=true&"
import script from "./p2.vue?vue&type=script&lang=js&"
export * from "./p2.vue?vue&type=script&lang=js&"
import style0 from "./p2.vue?vue&type=style&index=0&id=5835823e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835823e",
  null
  
)

export default component.exports